import { render } from "./Step3.vue?vue&type=template&id=77f24bc6&ts=true"
import script from "./Step3.ts?vue&type=script&lang=ts"
export * from "./Step3.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__